import {
  SESSION_SUBJECT_KEY,
  clearDistrictScopedCaches,
  clearHandoffMarker,
  clearTabDistrictCaches,
} from './impersonation';

export function claimDistrictCaches(sub: string | null): void {
  let shared: string | null = null;
  let thisTab: string | null = null;
  try {
    shared = localStorage.getItem(SESSION_SUBJECT_KEY);
    thisTab = sessionStorage.getItem(SESSION_SUBJECT_KEY);
  } catch {
    shared = null;
    thisTab = null;
  }
  if (sub === null || shared !== sub) {
    clearDistrictScopedCaches();
    clearHandoffMarker();
  } else if (thisTab !== sub) {
    clearTabDistrictCaches();
    clearHandoffMarker();
  }
  try {
    for (const storage of [localStorage, sessionStorage]) {
      if (sub) storage.setItem(SESSION_SUBJECT_KEY, sub);
      else storage.removeItem(SESSION_SUBJECT_KEY);
    }
  } catch {
    return;
  }
}
